const CircleCheck = ({ size=15, color="#12a87a", ...props }) => (
    <svg
        width={size}
        height={size}
        viewBox="3 -1 20 24"
        fill="none"
        {...props}
    >
        {/* Circle */}
        <circle
            cx="12" cy="12" r="9"
            stroke={color}
            strokeWidth="2"
        />
        {/* Check */}
        <path
            d="M8 12L11 15L16 9"
            stroke={color}
            strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
        />
    </svg>
);

export default CircleCheck;
